export class CategoryBaseResponse {
  constructor(
    public Name: string,
    public RetainDays: number,
    public UseRetainDays: boolean,
    public IsArchived: boolean,
    public IsDefault: boolean,
    public CadCategories: CadCategoryResponse[],
    public AppliedOnFiles: number,
    public UID: string
  ) {}
}

export class CategoryBase {
  constructor(
    public name: string,
    public retainDays: number,
    public useRetainDays: boolean,
    public isArchived: boolean,
    public isDefault: boolean,
    public cadCategories: CadCategory[],
    public appliedOnFiles: number,
    public uid: string
  ) {}
}

export class CadCategory {
  constructor(public name: string, public uid: string) {}
}

export class CadCategoryResponse {
  constructor(public Uid: string, public Name: string) {}
}

export class CadCategoryRequest {
  constructor(public Name: string, public Uid?: string) {}
}
